/**
 * Accessible tabs (WAI-ARIA Tabs pattern - MANUAL activation):
 * https://www.w3.org/WAI/ARIA/apg/patterns/tabs/#manualactivation
 * Markup: template-parts/components/content/tablist.php.
 *
 * Arrow/Home/End keys only MOVE FOCUS between tabs - they do not switch the
 * panel. The panel only changes on an explicit activation: a click, or
 * Enter/Space on the currently focused tab.
 */

function lhmMoveFocus(tabs, index) {
    tabs.forEach((tab, i) => {
        tab.setAttribute('tabindex', i === index ? '0' : '-1');
    });
    tabs[index].focus();
}

function lhmActivateTab(tabs, panels, index) {
    tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });

    panels.forEach((panel, i) => {
        if (i === index) {
            panel.removeAttribute('hidden');
        } else {
            panel.setAttribute('hidden', '');
        }
    });
}

function lhmTabsCanSlide() {
    return window.innerWidth < 1366;
}

function lhmScrollActiveTabIntoView(tab) {
    const outer = tab.closest('.tabsTablistOuter');

    if (!outer || !lhmTabsCanSlide() || !outer.classList.contains('tabsTablistOuter-hasOverflow')) {
        return;
    }

    const peek = tab.offsetWidth * 0.5;
    const target = Math.max(0, tab.offsetLeft - peek);
    outer.scrollTo({ left: target, behavior: 'smooth' });
}

function lhmUpdateTabsOverflow(outer) {
    const tablist = outer.querySelector('.tabsTablist');

    if (!tablist) {
        return;
    }

    outer.classList.remove('tabsTablistOuter-hasOverflow');

    if (!lhmTabsCanSlide()) {
        return;
    }

    const overflows = tablist.scrollWidth > outer.clientWidth;
    outer.classList.toggle('tabsTablistOuter-hasOverflow', overflows);
}

function lhmInitTabsElement(tablist) {
    const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
    if (tabs.length === 0) {
        return;
    }

    const panels = tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
    let focusedIndex = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
    if (focusedIndex === -1) {
        focusedIndex = 0;
    }

    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
            focusedIndex = index;
            lhmMoveFocus(tabs, focusedIndex);
            lhmActivateTab(tabs, panels, focusedIndex);
            lhmScrollActiveTabIntoView(tabs[focusedIndex]);
        });

        tab.addEventListener('keydown', (event) => {
            switch (event.key) {
                case 'ArrowRight':
                case 'ArrowDown':
                    event.preventDefault();
                    focusedIndex = (index + 1) % tabs.length;
                    lhmMoveFocus(tabs, focusedIndex);
                    break;
                case 'ArrowLeft':
                case 'ArrowUp':
                    event.preventDefault();
                    focusedIndex = (index - 1 + tabs.length) % tabs.length;
                    lhmMoveFocus(tabs, focusedIndex);
                    break;
                case 'Home':
                    event.preventDefault();
                    focusedIndex = 0;
                    lhmMoveFocus(tabs, focusedIndex);
                    break;
                case 'End':
                    event.preventDefault();
                    focusedIndex = tabs.length - 1;
                    lhmMoveFocus(tabs, focusedIndex);
                    break;
                case 'Enter':
                case ' ':
                case 'Spacebar':
                    event.preventDefault();
                    lhmActivateTab(tabs, panels, index);
                    lhmScrollActiveTabIntoView(tabs[index]);
                    break;
                default:
                    break;
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.tabsTablist').forEach(lhmInitTabsElement);

    const overflowOuters = Array.from(document.querySelectorAll('.tabsTablistOuter'));
    overflowOuters.forEach(lhmUpdateTabsOverflow);

    let resizeTimeout = null;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            overflowOuters.forEach(lhmUpdateTabsOverflow);
        }, 150);
    }, { passive: true });
});
